var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultMerchandise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1671079409949,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2721,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M569.5 733.3L439.8 571.2c-20.5-25.6-57.8-29.7-83.3-9.3-3.4 2.7-6.5 5.9-9.3 9.3L156.3 809.8h711.6L737.4 635.9c-19.6-26.2-56.8-31.5-83-11.9-4.5 3.4-8.5 7.4-11.9 11.9l-73 97.4zM156.3 98.2h711.6c32.7 0 59.3 26.5 59.3 59.3v711.6c0 32.7-26.5 59.3-59.3 59.3H156.3c-32.7 0-59.3-26.5-59.3-59.3V157.5c0-32.7 26.6-59.3 59.3-59.3zM690 454c65.5 0 118.6-53.1 118.6-118.6S755.5 216.8 690 216.8s-118.6 53.1-118.6 118.6S624.5 454 690 454z",
    "p-id": 2722,
    fill: "#bfbfbf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultMerchandise);
export default __webpack_public_path__ + "static/media/default-merchandise.3f2c21e59ef972e38601b7e2547d3865.svg";
export { ForwardRef as ReactComponent };